import { resources } from ".";
import { DEFAULT_LOCALE } from "../constants/locale";

interface NestedStringObject {
  [key: string]: string | number | NestedStringObject
}

export const deepMerge = (target: NestedStringObject, source: NestedStringObject): NestedStringObject => {
  const result = { ...target };
  for (const key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      result[key] = typeof source[key] === "object" && source[key] !== null
        ? deepMerge(result[key] as NestedStringObject ?? {}, source[key])
        : source[key];
    }
  }
  return result;
};

const mergeNestedObjects = (target: NestedStringObject, source: NestedStringObject): NestedStringObject => {
  const result = { ...target };
  for (const key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      const sourceValue = source[key];
      result[key] = typeof sourceValue === "object" && sourceValue !== null ? mergeNestedObjects((result[key] as NestedStringObject) ?? {}, sourceValue) : sourceValue;
    }
  }
  return result;
};

export const getLocalizationsFor = (locale: string): NestedStringObject => {
  const resourcesObj = resources[locale.toLowerCase() as keyof typeof resources];
  if (!resourcesObj) {
    console.warn(`Localization for ${locale} not found, falling back to default locale ${DEFAULT_LOCALE}.`);
    return resources[DEFAULT_LOCALE.toLowerCase() as keyof typeof resources];
  }
  return mergeNestedObjects(resources[DEFAULT_LOCALE.toLowerCase() as keyof typeof resources], resourcesObj);
};
